import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jia",
  "use": "icon-jia-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jia\"><path d=\"M60.51 446.836h902.98c32.583 0 60.51 27.928 60.51 60.51 0 32.581-27.927 60.509-60.51 60.509H60.51c-32.583 0-60.51-27.928-60.51-60.51 0-34.909 27.927-60.509 60.51-60.509z\" /><path d=\"M572.51 60.51v902.98c0 32.583-27.928 60.51-60.51 60.51-32.582 0-60.51-27.927-60.51-60.51V60.51C451.49 27.926 479.419 0 512 0c32.582 0 60.51 27.927 60.51 60.51z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol